import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchConfigurationCompanyCodes = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_COMPANY_CODES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Company Codes' }))
  .then(parseAsJson);

export const fetchConfigurationBusinessUnits = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_BUSINESS_UNITS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Business Units' }))
  .then(parseAsJson);

export const fetchConfigurationLegalEntities = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_LEGAL_ENTITIES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Legal Entities' }))
  .then(parseAsJson);

export const fetchConfigurationTaxRates = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_TAX_RATES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Tax Rates' }))
  .then(parseAsJson);

export const fetchConfigurationBookToTaxDifferences = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_BOOK_TO_TAX_DIFFERENCES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Book to Tax Differences' }))
  .then(parseAsJson);

export const fetchConfigurationObligations = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_OBLIGATIONS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Obligations' }))
  .then(parseAsJson);

export const fetchConfigurationTaxBookingEntities = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_TAX_BOOKING_ENTITIES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Tax Booking Entities' }))
  .then(parseAsJson);

export const fetchConfigurationTLSAccounts = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_TLS_ACCOUNTS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration TLS Accounts' }))
  .then(parseAsJson);

export const fetchConfigurationTaxAccounting = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_TAX_ACCOUNTING
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Tax Accounting' }))
  .then(parseAsJson);

export const fetchConfigurationUsers = () => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_USERS
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Users' }))
  .then(parseAsJson);

export const fetchConfigurationGlJournals = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_GL_JOURNALS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration GL Journals' }))
  .then(parseAsJson);

export const fetchConfigurationCurrencies = () => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_CURRENCIES
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Currencies' }))
  .then(parseAsJson);

export const fetchConfigurationPeriods = () => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_PERIODS
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Periods' }))
  .then(parseAsJson);

export const fetchConfigurationCurrencyConversionRates = periodName => fetch(
  Config.endpoints.FETCH_CONFIGURATION_SETTINGS_CURRENCY_CONVERSION_RATES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Error Fetching Configuration Currency Conversion Rates' }))
  .then(parseAsJson);
